import { config } from "src/config/config";
import { AjaxStatus } from "src/service/api_types";
import {
  getSaleAssetsByBrandAPI,
  getRentalAssetsByBrandAPI,
  getTradingAssetsAPI,
  getTradableListedAssetsAPI,
  getGroupsByBrandAPI,
} from "src/service/public_asset_api";

export const PUBLIC_ASSET_ACTIONS = {
  INIT_SALE_ASSETS_BY_BRAND: "INIT_SALE_ASSETS_BY_BRAND",
  START_SALE_ASSETS_BY_BRAND: "START_SALE_ASSETS_BY_BRAND",
  GET_SALE_ASSETS_BY_BRAND: "GET_SALE_ASSETS_BY_BRAND",
  INIT_RENTAL_ASSETS_BY_BRAND: "INIT_RENTAL_ASSETS_BY_BRAND",
  START_RENTAL_ASSETS_BY_BRAND: "START_RENTAL_ASSETS_BY_BRAND",
  GET_RENTAL_ASSETS_BY_BRAND: "GET_RENTAL_ASSETS_BY_BRAND",
  INIT_TRADING_ASSETS: "INIT_TRADING_ASSETS",
  START_TRADING_ASSETS: "START_TRADING_ASSETS",
  GET_TRADING_ASSETS: "GET_TRADING_ASSETS",
  INIT_TRADABLE_LISTED_ASSETS: "INIT_TRADABLE_LISTED_ASSETS",
  START_TRADABLE_LISTED_ASSETS: "START_TRADABLE_LISTED_ASSETS",
  GET_TRADABLE_LISTED_ASSETS: "GET_TRADABLE_LISTED_ASSETS",
  INIT_GROUPS_BY_BRAND: "INIT_GROUPS_BY_BRAND",
  START_GROUPS_BY_BRAND: "START_GROUPS_BY_BRAND",
  GET_GROUPS_BY_BRAND: "GET_GROUPS_BY_BRAND",
};

export const initGetSaleAssetsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.INIT_SALE_ASSETS_BY_BRAND,
});

export const startGetSaleAssetsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.START_SALE_ASSETS_BY_BRAND,
});

export const getSaleAssetsByBrand = (data: any) => ({
  type: PUBLIC_ASSET_ACTIONS.GET_SALE_ASSETS_BY_BRAND,
  data,
});

export const initGetRentalAssetsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.INIT_RENTAL_ASSETS_BY_BRAND,
});

export const startGetRentalAssetsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.START_RENTAL_ASSETS_BY_BRAND,
});

export const getRentalAssetsByBrand = (data: any) => ({
  type: PUBLIC_ASSET_ACTIONS.GET_RENTAL_ASSETS_BY_BRAND,
  data,
});

export const initGetTradingAssets = () => ({
  type: PUBLIC_ASSET_ACTIONS.INIT_TRADING_ASSETS,
});

export const startGetTradingAssets = () => ({
  type: PUBLIC_ASSET_ACTIONS.START_TRADING_ASSETS,
});

export const getTradingAssets = (data: any) => ({
  type: PUBLIC_ASSET_ACTIONS.GET_TRADING_ASSETS,
  data,
});

export const initGetTradableListedAssets = () => ({
  type: PUBLIC_ASSET_ACTIONS.INIT_TRADABLE_LISTED_ASSETS,
});

export const startGetTradableListedAssets = () => ({
  type: PUBLIC_ASSET_ACTIONS.START_TRADABLE_LISTED_ASSETS,
});

export const getTradableListedAssets = (data: any) => ({
  type: PUBLIC_ASSET_ACTIONS.GET_TRADABLE_LISTED_ASSETS,
  data,
});

export const initGetGroupsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.INIT_GROUPS_BY_BRAND,
});

export const startGetGroupsByBrand = () => ({
  type: PUBLIC_ASSET_ACTIONS.START_GROUPS_BY_BRAND,
});

export const getGroupsByBrand = (data: any) => ({
  type: PUBLIC_ASSET_ACTIONS.GET_GROUPS_BY_BRAND,
  data,
});

export const getSaleAssetsByBrandDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      sortBy: params.sortBy,
      account: params.account,
    };

    dispatch(startGetSaleAssetsByBrand());

    return getSaleAssetsByBrandAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets: ", data.sale_assets);
        }
        const assetsData = {
          pageNumber: params.pageNumber,
          response: data.sale_assets,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getSaleAssetsByBrand(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting sale assets in the brand");
        }
        dispatch(
          getSaleAssetsByBrand({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const getRentalAssetsByBrandDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      sortBy: params.sortBy,
      account: params.account,
    };

    dispatch(startGetRentalAssetsByBrand());

    return getRentalAssetsByBrandAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets: ", data.rental_assets);
        }
        const assetsData = {
          pageNumber: params.pageNumber,
          response: data.rental_assets,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getRentalAssetsByBrand(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting rental assets in the brand");
        }
        dispatch(
          getRentalAssetsByBrand({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const getTradingAssetsDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      tradingAssetTokenIds: params.trading_asset_token_ids,
      // pageNumber: params.pageNumber,
      // pageSize: params.pageSize,
      // sortBy: params.sortBy,
      account: params.account,
    };
    console.log("getTradingAssetsDispatch: " + options.tradingAssetTokenIds);

    dispatch(startGetTradingAssets());

    return getTradingAssetsAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets: ", data);
        }
        const assetsData = {
          // pageNumber: params.pageNumber,
          response: data,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getTradingAssets(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting trading assets");
        }
        dispatch(
          getTradingAssets({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const getTradableListedAssetsDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      tradingAssetTokenIds: params.trading_asset_token_ids,
      // pageNumber: params.pageNumber,
      // pageSize: params.pageSize,
      // sortBy: params.sortBy,
      account: params.account,
    };

    dispatch(startGetTradableListedAssets());

    return getTradableListedAssetsAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets: ", data);
        }
        const assetsData = {
          // pageNumber: params.pageNumber,
          response: data,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getTradableListedAssets(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting traadble assets");
        }
        dispatch(
          getTradableListedAssets({
            response: {},
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };

export const getGroupsByBrandDispatch =
  (params: any) => (dispatch: Function) => {
    const options = {
      pageNumber: params.pageNumber,
      pageSize: params.pageSize,
      sortBy: params.sortBy,
      account: params.account,
    };

    dispatch(startGetGroupsByBrand());

    return getGroupsByBrandAPI(options)
      .done((data, status, xhr) => {
        if (config.APP_DEBUG) {
          console.log("Headers: ", xhr.getAllResponseHeaders());
          console.log("Received assets: ", data);
        }
        const assetsData = {
          pageNumber: params.pageNumber,
          response: data,
          ajaxStat: AjaxStatus.DONE,
        };
        dispatch(getGroupsByBrand(assetsData));
      })
      .fail((err) => {
        if (config.APP_DEBUG) {
          console.error("Error in getting group assets in the brand");
        }
        dispatch(
          getGroupsByBrand({
            response: [],
            ajaxStat: AjaxStatus.FAILED,
          })
        );
      });
  };
